import 'bootstrap/js/dist/collapse';

export function initInScope ($scope) {
    $scope.find('.js-accordion-state').each(function() {
        let $this = $(this);
        let items = $this.find('.js-accordion-state__item');

        items.each(function(){
            let item = $(this);
            let collapse = item.find('.js-accordion-state__item-collapse');

            collapse.on('shown.bs.collapse', function(){
                items.addClass('is-inactive');
                item.removeClass('is-inactive');
            });
            collapse.on('hide.bs.collapse', function(){
                items.removeClass('is-inactive');
            });
        })
    })
}